import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import i18n from '@i18n';
import { SuperkurzyTournament } from './TournamentContent';
import { INTERVALS } from './dialog/byDate';
import BackToTop from '@/common/components/BackToTop';
import { closeSuperOffer, loadSuperOffer } from '@/nikeone/handlers';
import BetLocationContext, { betLocation } from 'nike-ui/src/common/BetLocationContext';

export const SuperkurzyVisibleDates = ['ALL', 'TODAY', 'HOUR', 'HOURS3', 'TOMORROW', 'TODAY_AND_TOMORROW'];

export function isSuperkurzySlugVisible(byDate) {
    return SuperkurzyVisibleDates.indexOf(byDate) > -1 || byDate === INTERVALS.TOMORROW.date[0];
}

class Banner extends React.PureComponent {
    render() {
        const { text, title, icon, className } = this.props;
        return (
            <>
                <div className={'banner ' + className}>
                    <div className={'icon-thumb-default ' + icon} />
                    <h1>{title}</h1>
                </div>
                <div className="description" dangerouslySetInnerHTML={{ __html: text }} />
            </>
        );
    }
}

function SuperKurzy() {
    const derefSub = useReframe();
    const superOfferBetsIds = derefSub(['nikeone/box/betIds', 'filteredBoxStore', 'superoffer']);
    const superChanceBetsIds = derefSub(['nikeone/box/betIds', 'filteredBoxStore', 'superchance']);
    const superBetsIds = superOfferBetsIds.size + superChanceBetsIds.size;
    useEffect(() => {
        dispatch(loadSuperOffer('filteredBoxStore'));
        return () => dispatch(closeSuperOffer('filteredBoxStore'));
    }, []);

    return (
        <div className="superkurzy">
            <Banner
                icon="icon-thumb-superponuka"
                text={i18n('nikeone.superkurzy.ponuka')}
                title={i18n('domain.enum.TypZvyhodnenia.SUPER_PONUKA')}
            />
            <BetLocationContext.Provider value={{ betLocationSection: betLocation.KURZY_OVERVIEW_SUPEROFFER }}>
                <SuperkurzyTournament boxStore="filteredBoxStore" boxId="superoffer" />
            </BetLocationContext.Provider>
            <Banner
                className="separ"
                icon="icon-thumb-supersanca"
                text={i18n('nikeone.superkurzy.sanca')}
                title={i18n('domain.enum.TypZvyhodnenia.SUPER_SANCA')}
            />
            <BetLocationContext.Provider value={{ betLocationSection: betLocation.KURZY_OVERVIEW_SUPERCHANCE }}>
                <SuperkurzyTournament boxStore="filteredBoxStore" boxId="superchance" />
            </BetLocationContext.Provider>
            {superBetsIds > 10 ? <BackToTop /> : null}
        </div>
    );
}

export default SuperKurzy;
